import request from "@/utils/request"
import {baseURL} from "../baseURL";

export function packageList(params) {
  return request({
    url: baseURL + '/package',
    method: 'post',
    data: params
  })
}

export function packageConfirm(params) {
  return request({
    url: baseURL + '/package/confirm',
    method: 'post',
    data: params
  })
}

export function packagePay(params) {
  return request({
    url: baseURL + '/package/pay',
    method: 'post',
    data: params
  })
}

export function packageCheck(params) {
  return request({
    url: baseURL + '/package/check',
    method: 'post',
    data: params
  })
}

export function orderStatus(params) {
  return request({
    url: baseURL + '/package/status',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/package/index.js